// Styles visuels des POI (catégorie / icône / couleur) — purement visuel, jamais métier.
export const CATEGORIES = [
  { key: "ARRET", label: "Arrêt", icon: "bus" },
  { key: "ECOLE", label: "École", icon: "school" },
  { key: "GARE", label: "Gare", icon: "train" },
  { key: "ETABLISSEMENT", label: "Établissement", icon: "building" },
  { key: "DEPOT", label: "Dépôt", icon: "warehouse" },
  { key: "PARKING", label: "Parking", icon: "parking" },
  { key: "PRISE_EN_CHARGE", label: "Prise en charge", icon: "pickup" },
  { key: "DEPOSE", label: "Dépose", icon: "dropoff" },
  { key: "AUTRE", label: "Autre", icon: "pin" },
];
export const PALETTE = ["#0A0A0B", "#FFC60A", "#DC2626", "#EA580C", "#059669", "#0284C7", "#7C3AED", "#DB2777", "#64748B", "#92400E"];
export const DEFAULT_COLOR = "#0A0A0B";
export const DEFAULT_ICON = "pin";
export const DEFAULT_CATEGORY = "AUTRE";

// Icônes inline (traits lucide simplifiés) — stroke = currentColor
const P = (d) => `<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">${d}</svg>`;
export const ICONS = {
  pin: P('<path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/>'),
  bus: P('<rect x="4" y="3" width="16" height="15" rx="2"/><path d="M4 11h16M8 18v2M16 18v2"/><circle cx="8" cy="15" r=".8"/><circle cx="16" cy="15" r=".8"/>'),
  school: P('<path d="M3 21V9l9-5 9 5v12"/><path d="M9 21v-6h6v6"/><path d="M3 12h18"/>'),
  train: P('<rect x="5" y="3" width="14" height="14" rx="3"/><path d="M5 10h14M9 21l1-3M15 21l-1-3"/><circle cx="9" cy="14" r=".8"/><circle cx="15" cy="14" r=".8"/>'),
  building: P('<rect x="4" y="3" width="16" height="18"/><path d="M9 7h2M13 7h2M9 11h2M13 11h2M9 15h2M13 15h2M10 21v-3h4v3"/>'),
  warehouse: P('<path d="M3 21V9l9-5 9 5v12"/><path d="M7 21v-7h10v7M7 17h10"/>'),
  parking: P('<rect x="4" y="3" width="16" height="18" rx="2"/><path d="M9 17V7h4a3 3 0 0 1 0 6H9"/>'),
  pickup: P('<circle cx="10" cy="7" r="3"/><path d="M4 21v-1a6 6 0 0 1 12 0v1"/><path d="M19 8v6M16 11h6"/>'),
  dropoff: P('<circle cx="10" cy="7" r="3"/><path d="M4 21v-1a6 6 0 0 1 12 0v1"/><path d="M16 11h6"/>'),
  flag: P('<path d="M5 21V4h12l-2 4 2 4H5"/>'),
  star: P('<path d="m12 3 2.8 5.7 6.2.9-4.5 4.4 1 6.2L12 17.3 6.5 20.2l1-6.2L3 9.6l6.2-.9Z"/>'),
  circle: P('<circle cx="12" cy="12" r="6"/>'),
};
export const ICON_KEYS = Object.keys(ICONS);

export function styleOf(stop) {
  const category = stop?.category || DEFAULT_CATEGORY;
  const catDef = CATEGORIES.find((c) => c.key === category);
  return {
    category,
    categoryLabel: catDef?.label || "Autre",
    icon: stop?.icon_key || catDef?.icon || DEFAULT_ICON,
    color: stop?.color || DEFAULT_COLOR,
    styled: !!(stop?.category || stop?.icon_key || stop?.color),
  };
}

export function contrastText(hex) {
  const c = (hex || DEFAULT_COLOR).replace("#", "");
  const r = parseInt(c.slice(0, 2), 16), g = parseInt(c.slice(2, 4), 16), b = parseInt(c.slice(4, 6), 16);
  return (r * 299 + g * 587 + b * 114) / 1000 > 150 ? "#0A0A0B" : "#FFFFFF";
}

export function markerHtml({ color, icon, size = 24, selected = false, inactive = false, moving = false, badge = "" }) {
  const bg = moving ? "#EA580C" : color;
  const fg = contrastText(bg);
  const ring = selected ? "box-shadow:0 0 0 3px #FFC60A;" : moving ? "box-shadow:0 0 0 4px rgba(234,88,12,.35);" : "";
  const dim = inactive ? "opacity:.45;filter:grayscale(70%);" : "";
  const inner = badge ? `<span style="font-family:'IBM Plex Mono',monospace;font-weight:800;font-size:12px">${badge}</span>` : (ICONS[icon] || ICONS.pin);
  return `<div style="width:${size}px;height:${size}px;background:${bg};color:${fg};border:2px solid #0A0A0B;border-radius:999px;display:flex;align-items:center;justify-content:center;${ring}${dim}cursor:${moving ? "grab" : "pointer"};">${inner}</div>`;
}
